import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useNashr } from './State';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { editNashr, ed } = useNashr()
    let [form] = useForm()
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form
            form={form}
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={editNashr}
            autoComplete="off"
        >
            <Form.Item hidden name={'id'}>
                <Input />
            </Form.Item>
            <Form.Item label="Nashriyot nomi" name={'nashriyot'}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">Saqlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;